<div mat-dialog-title class="dialog-header-container">

    <button matIconButton (click)="closeCollection()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    @if (status) {
        <div class="header-content ">
          <span class="mat-font-title-md" id="address-text" >{{ status.address }}</span>
          <span class="mat-text-secondary mat-font-title-sm">{{ selectedCollection ? selectedCollection.year + " Imagery" : "Yearly Collections" }}</span>
        </div>
    }
    <button matIconButton class="close-button" (click)="closeGallery()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

<mat-dialog-content>
    @if (selectedCollection) {
        <div class="filter-panel">
            <div class="image-filters">
                @if (visibleLayers?.length) {
                    <mat-button-toggle-group
                            [hideMultipleSelectionIndicator]="true"
                            multiple
                            class="filter-group"
                            name="categories"
                            [value]="[selectedFilter.layername]"
                            (change)="changeCategory($event)"
                            aria-label="Image category">
                        @if (visibleLayers.includes('bluesky')) {
                            <mat-button-toggle [class.locked]="categoryLocked()" value="bluesky">Blue Sky</mat-button-toggle>
                        }
                        @if (visibleLayers.includes('graysky')) {
                            <mat-button-toggle [class.locked]="categoryLocked()" value="graysky">Gray Sky</mat-button-toggle>
                        }
                    </mat-button-toggle-group>
                }
                @if (visibleResolutions?.length) {
                    <mat-button-toggle-group
                            multiple
                            [hideMultipleSelectionIndicator]="true"
                            class="filter-group"
                            name="resolutions"
                            [value]="[selectedFilter.resolution]"
                            (change)="changeResolution($event)"
                            aria-label="Image resolution">
                        @if (visibleResolutions.includes('ultra')) {
                            <mat-button-toggle [class.locked]="resolutionLocked()" value="ultra">Urban</mat-button-toggle>
                        }
                        @if (visibleResolutions.includes('high')) {
                            <mat-button-toggle [class.locked]="resolutionLocked()" value="high">Wide Area</mat-button-toggle>
                        }
                    </mat-button-toggle-group>
                }
                @if (visibleOrientations?.length) {
                    <mat-button-toggle-group
                            multiple
                            class="filter-group"
                            [value]="[selectedFilter.orientation]"
                            (change)="changeOrientation($event)"
                            aria-label="Image orientation">
                        @if (visibleOrientations.includes('N*')) {
                            <mat-button-toggle value="N*">Vertical</mat-button-toggle>
                        }
                        @if (visibleOrientations.includes('N')) {
                            <mat-button-toggle value="N">North</mat-button-toggle>
                        }
                        @if (visibleOrientations.includes('S')) {
                            <mat-button-toggle value="S">South</mat-button-toggle>
                        }
                        @if (visibleOrientations.includes('E')) {
                            <mat-button-toggle value="E">East</mat-button-toggle>
                        }
                        @if (visibleOrientations.includes('W')) {
                            <mat-button-toggle value="W">West</mat-button-toggle>
                        }
                    </mat-button-toggle-group>
                }
            </div>
            @if (images.length) {
                <span class="small-info-text">Showing {{ filteredImages?.length || 0 }} of {{ images.length }}</span>
            }
        </div>
    }

    @if (selectedCollection) {
        <div #galleryContainer class="selected-collection-wrapper collections-wrapper" id="image-scroll">
            @for (image of filteredImages; track image.image_id) {
                <phoenix-gallery-image
                        class="dialog-image"
                        [enableDebugOptions]="enableDebugOptions"
                        [galleryService]="galleryService"
                        [isSelected]="selectedImage && selectedImage.image_id === image.image_id"
                        [attr.image-id]="image.image_id"
                        [mode]="this.mode"
                        [image]="image"
                        (click)="showFullscreen(image, $index, $event)"></phoenix-gallery-image>
            }
        </div>
    } @else {
        <div class="nonselected-collection-wrapper collections-wrapper" id="years-scroll">
            @for (collection of collectionsReverse; track collection.year) {
                <mat-card class="collection-cover m-1" (click)="selectCollection(collection)">
                    @if (isLoading[collection.year]) {
                        <div mat-card-image class="loading"></div>
                    }
                    <custom-gallery-image class="p-2"
                            [src]="collection.images[0]?.previewTileURl"
                            [className]="isLoading[collection.year] ? 'loading-image' : 'mat-card-image'"
                            (loadEvent)="hideLoaders(collection.year)"></custom-gallery-image>

                    <span [className]="isLoading[collection.year] ? 'cover-year-label loading-text-mask' : 'cover-year-label'">{{ collection.year }}</span>
                    <mat-card-content>
                        <span class="small-info-text">{{ collection.images.length }} images</span>
                    </mat-card-content>
                </mat-card>
            }
        </div>
    }
</mat-dialog-content>

<lib-full-screen-loading [isShown]="isFullscreenLoaderShown"></lib-full-screen-loading>
